import {
  impersonatableUserState,
  isImpersonatingState,
} from "@common/state/impersonsonatingUser";
import { Body } from "@hypercard/web-components";
import { useRecoilValue } from "recoil";
import { twMerge } from "tailwind-merge";

const SPACE_CN = "left-0 right-0 top-0 p-2";

export const ImpersonatingUser = () => {
  const isImpersonating = useRecoilValue(isImpersonatingState);
  const impersonatableState = useRecoilValue(impersonatableUserState);

  if (isImpersonating) {
    return (
      <>
        {/* This is always hidden, but used to take up space */}
        <div className={twMerge("invisible sticky", SPACE_CN)}>
          <Body size="sm" weight="regular">
            Hidden
          </Body>
        </div>
        {/* Make this fixed, so it doesn't scroll with the page */}
        <div
          className={twMerge(
            "fixed flex items-center justify-center bg-[#D19C4C]",
            SPACE_CN,
          )}
        >
          <Body size="sm" weight="regular" className="text-black">
            {`Viewing as ${impersonatableState.impersonatingUser?.displayName}`}
          </Body>
        </div>
      </>
    );
  }

  return null;
};
